import { gql } from "@apollo/client";

export const USER_DELETE_IMPACT = gql`
  query UserDeleteImpact($id: ID!) {
    userDeleteImpact(id: $id) {
      jobsCreated
      jobsAssigned
      jobApplications
      meetingsAttached
      hasImpact
    }
  }
`;

// Users Info
export const GET_USERS = gql`
  query GetUsers {
    users {
      _id
      username
      email
      timezone
      admin
      attributes {
        key
        value
      }
    }
  }
`;

// User Info
export const QUERY_USER = gql`
  query User($username: String!) {
    user(username: $username) {
      _id
      username
      email
      admin
      about
      assignedJobs {
        assignedAt
        job {
          _id
          active
          description
          createdAt
        }
      }
      attributes {
        key
        value
      }
    }
  }
`;

export const QUERY_ME = gql`
  query Me {
    me {
      _id
      username
      email
      admin
      timezone
      onboarding {
        required
        missingProfileFields
        missingAttributeKeys
        attributeSchemaVersion
        completedSchemaVersion
        completedAt
      }
      assignedJobs {
        assignedAt
        job {
          _id
          active
          description
          createdAt
        }
      }
      attributes {
        key
        value
      }
    }
  }
`;

export const QUERY_MY_JOB_STATS = gql`
  query GetMyJobStats {
    myJobStats {
      _id
      username
      createdCount
      assignedCount
      appliedCount
      totalMeetingsHosted
      totalSubJobs
      totalUnassignedApplications
    }
  }
`;


export const QUERY_CALENDARS = gql`
  query {
    googleCalendars {
      id
      summary
      primary
      backgroundColor
      foregroundColor
      accessRole
    }
  }
`;

export const QUERY_EVENTS = gql`
  query ($calendarId: String!) {
    googleEvents(calendarId: $calendarId) {
      id
      summary
      start
      end
      description
      calendarId
      }
    }
`;

